import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-brand-cream px-4 py-5 sm:px-6" aria-labelledby="guarantee-heading" data-id="element-73" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl rounded-xl border border-brand-teal/50 bg-white p-4 text-center shadow-sm" data-id="element-74" data-mp="223685s65k1rq">
        <div className="mx-auto mb-1.5 flex h-10 w-10 items-center justify-center rounded-full bg-brand-green/15" data-id="element-75" data-mp="1x41zr3r1y82g">
          <ShieldCheckIcon className="h-5 w-5 text-brand-navy" aria-hidden="true" data-id="element-76" data-mp="19fismrjqo1by" />
        </div>
        <h2 id="guarantee-heading" className="mb-1 text-lg font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-77" data-mp="14gpgp3k3oidw">
          Your Investment Is 100% Protected
        </h2>
        <p className="text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-78" data-mp="1ec98pevjmwxd">
          Take seven full days to explore every module, review the drills, use the session
          structures, study the development programs, and try the professional coaching tools. If
          you decide the system isn't right for you, simply contact us within the first 7 days and
          we'll refund 100% of your purchase.
        </p>
        <p className="mt-1 text-[12px] font-extrabold text-brand-green sm:text-sm" data-id="element-79" data-mp="tw9rz8fmm8b3">
          No questions asked.
        </p>
      </div>
    </section>;
}